import React, { useEffect } from "react";
import { GoogleAdConfig, destroyAdSlot, initializeInterstitialAdSlot } from "../../services";
import { useSelector } from "react-redux";
import { selectProfileLoading, selectUserInfo } from "../../routes/Auth/auth.ducks";

export interface GoogleAdProps {
  config: GoogleAdConfig;
}

const GoogleAdComponent = (props: GoogleAdProps) => {
  const { config } = props;

  useEffect(() => {
    initializeInterstitialAdSlot(config);

    return () => {
      destroyAdSlot(config);
    };
  }, []);

  return null;

}

function GoogleAdInterstitial(props: GoogleAdProps) {
  const userInfo = useSelector(selectUserInfo);
  const profileLoading = useSelector(selectProfileLoading);
  const userHasIndexPremium = userInfo && userInfo.hasIndexPremium;

  if (profileLoading || userHasIndexPremium) {
    return null;
  }

  return <GoogleAdComponent {...props} />

}

GoogleAdInterstitial.defaultProps = {
};

export default React.memo(GoogleAdInterstitial);



// WEBPACK FOOTER //
// ./src/components/GoogleAdInterstitial/index.tsx